(() => {
  const root = document.querySelector('[data-personaliser]');
  if (!root) return;
  const q = s => root.querySelector(s), api = root.dataset.api;
  const form = root.closest('form'), buy = form.querySelector('button[type="submit"]');
  const soldOut = buy.disabled, media = document.querySelector('.product-media .merch-body img');
  const original = media.getAttribute('src'), originalAlt = media.alt;
  const file = q('input[type="file"]'), consent = q('[data-consent]'), generate = q('[data-generate]');
  const key = 'eightiesxmas-personalisation-v3-' + root.dataset.design;
  let state = {}, busy = false, polling = false, previewUrl = '', sourceUrl = '', epoch = 0;
  const custom = () => q('[value="custom"]').checked;
  const say = (text, error = false) => { q('[data-status]').textContent = text; q('[data-status]').classList.toggle('is-error', error); };
  function save() { try { sessionStorage.setItem(key, JSON.stringify(state)); } catch (_) {} }
  function clearStorage() { try { sessionStorage.removeItem(key); } catch (_) {} }
  function sync() {
    q('[data-custom-panel]').hidden = !custom();
    const ready = ['awaiting_approval', 'approved'].includes(state.status);
    q('[data-upload-fields]').hidden = ready;
    q('[data-change]').hidden = !ready;
    buy.disabled = soldOut || (custom() && state.status !== 'approved');
    generate.disabled = busy || !file.files.length || !consent.checked;
    file.disabled = busy; consent.disabled = busy;
    q('[data-review]').hidden = !previewUrl || state.status !== 'awaiting_approval';
    q('[data-approved]').hidden = state.status !== 'approved';
    q('[data-property="label"]').value = 'Custom face — preview approved';
    q('[data-property="id"]').value = state.id || '';
    q('[data-property="artwork"]').value = state.artwork_url || '';
    root.querySelectorAll('[data-property]').forEach(el => el.disabled = !custom() || state.status !== 'approved');
    media.src = custom() && previewUrl ? previewUrl : original;
    media.alt = custom() && previewUrl ? 'Your personalised artwork preview' : originalAlt;
    q('[data-full-preview]').src = previewUrl || original;
  }
  async function request(path, options = {}) {
    const headers = new Headers(options.headers);
    if (state.token) headers.set('Authorization', 'Bearer ' + state.token);
    const response = await fetch(api + path, {...options, headers, signal: AbortSignal.timeout(30000)});
    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      if (response.status === 401) { state = {}; clearStorage(); }
      throw new Error(typeof data.detail === 'string' ? data.detail : 'We could not complete that request. Please try again.');
    }
    return response;
  }
  async function image() {
    const response = await request('/storefront/jobs/' + state.id + '/image');
    if (previewUrl.startsWith('blob:')) URL.revokeObjectURL(previewUrl);
    previewUrl = URL.createObjectURL(await response.blob());
  }
  async function poll() {
    if (polling) return;
    polling = true; busy = true; sync(); q('[data-check]').hidden = true;
    const current = epoch;
    try {
      for (let n = 0; n < 100; n++) {
        const result = await (await request('/storefront/jobs/' + state.id)).json();
        if (current !== epoch) return;
        Object.assign(state, result); save();
        if (['awaiting_approval', 'approved'].includes(result.status)) {
          await image();
          say(result.status === 'approved' ? 'Your design is approved and ready to add to the bag.' : 'Your preview is ready. Take a look, then choose “Use this design”.');
          return;
        }
        if (['rejected', 'failed'].includes(result.status)) {
          say(result.error || 'We could not make a suitable preview. Please choose a different photo.', true);
          state = {}; clearStorage(); return;
        }
        say(result.status === 'queued' ? 'Your photo is in the queue. This usually takes a few minutes.' : 'We’re drawing your face into the artwork. You can keep this page open while we work.');
        await new Promise(resolve => setTimeout(resolve, 4000));
      }
      throw new Error('Your preview is taking longer than usual. Check again shortly; you will not need to upload again.');
    } catch (error) {
      say(error.message || 'The connection was interrupted. Check your existing preview again.', true);
      q('[data-check]').hidden = !state.id;
    } finally { polling = false; busy = false; sync(); }
  }
  root.querySelectorAll('[name="design-choice"]').forEach(el => el.addEventListener('change', () => { state.custom = custom(); save(); sync(); }));
  consent.addEventListener('change', sync);
  file.addEventListener('change', () => {
    epoch++; state = {}; clearStorage();
    if (previewUrl.startsWith('blob:')) URL.revokeObjectURL(previewUrl);
    previewUrl = '';
    if (sourceUrl) URL.revokeObjectURL(sourceUrl);
    const selected = file.files[0];
    if (selected && (!['image/jpeg', 'image/png', 'image/webp'].includes(selected.type) || selected.size > 8 * 1024 * 1024)) {
      file.value = ''; q('[data-source-photo]').hidden = true;
      say('Choose a JPG, PNG or WebP image smaller than 8 MB.', true);
    } else {
      sourceUrl = selected ? URL.createObjectURL(selected) : '';
      q('[data-source-photo]').src = sourceUrl; q('[data-source-photo]').hidden = !selected;
      say(selected ? 'Your photo is selected. Confirm permission, then create your preview.' : '');
    }
    q('[data-check]').hidden = true; sync();
  });
  generate.addEventListener('click', async () => {
    if (!file.files.length || !consent.checked || busy) return;
    busy = true; sync(); say('Uploading your photo and checking that it contains one clear face…');
    try {
      if (state.id) { busy = false; return poll(); }
      if (!state.token) {
        const response = await request('/storefront/sessions', {method: 'POST'});
        state = {...await response.json(), created: Date.now()}; save();
      }
      const data = new FormData(); data.append('photo', file.files[0]); data.append('consent', 'true');
      const result = await (await request('/storefront/jobs', {method: 'POST', body: data})).json();
      Object.assign(state, result); save(); busy = false; await poll();
    } catch (error) {
      say(error.message || 'The upload was interrupted. Try again with the same photo.', true);
      busy = false; sync();
    }
  });
  q('[data-check]').addEventListener('click', poll);
  q('[data-change]').addEventListener('click', () => {
    epoch++; state = {}; clearStorage(); previewUrl = ''; file.value = ''; consent.checked = false;
    q('[data-source-photo]').hidden = true; say('Choose a new photo to create another preview.'); sync();
  });
  q('[data-approve]').addEventListener('click', async () => {
    q('[data-approve]').disabled = true;
    try {
      Object.assign(state, await (await request('/storefront/jobs/' + state.id + '/approve', {method: 'POST'})).json());
      save(); say('Your design is approved and ready to add to the bag.'); sync();
    } catch (error) { say(error.message, true); }
    finally { q('[data-approve]').disabled = false; }
  });
  q('[data-enlarge]').addEventListener('click', () => q('[data-dialog]').showModal());
  q('[data-close]').addEventListener('click', () => q('[data-dialog]').close());
  form.addEventListener('submit', event => {
    if (custom() && state.status !== 'approved') {
      event.preventDefault(); say('Create and approve your preview before adding this personalised gift to the bag.', true);
      q('[data-status]').scrollIntoView({block: 'center', behavior: 'smooth'});
    }
  });
  try {
    const saved = JSON.parse(sessionStorage.getItem(key) || '{}');
    if (saved.token && saved.id && Date.now() - saved.created < 86400000) {
      state = saved; q('[value="custom"]').checked = saved.custom !== false; poll();
    }
  } catch (_) {}
  sync();
})();
